/**
 * OVERRIDE Footer.jsx
 * REASON: odc usa Footer customizado, Semantic UI-free (ver docs cookbook Receita 2).
 * FILE: shadow file — apenas re-exporta o componente real do addon.
 */
import Footer from 'odc.volto/components/Footer/Footer';

export default Footer;
